import { type AxiosRequestConfig } from 'axios'

const updateUserOtherInfo = (data: any): AxiosRequestConfig => {
  return {
    method: 'Put',
    url: '/user/info/other',
    data,
  }
}

export { updateUserOtherInfo }
